module.exports = __webpack_public_path__ + "img/adesivagem_vidro.f06ab86f.jpg";